import { RetrySendMessage, useChannelActionContext } from '../../../context/ChannelActionContext';

import type { DefaultBeloChatGenerics } from '../../../types/types';

export const useRetryHandler = <
  BeloChatGenerics extends DefaultBeloChatGenerics = DefaultBeloChatGenerics
>(
  customRetrySendMessage?: RetrySendMessage<BeloChatGenerics>,
): RetrySendMessage<BeloChatGenerics> => {
  const { retrySendMessage: contextRetrySendMessage } = useChannelActionContext<BeloChatGenerics>(
    'useRetryHandler',
  );

  const retrySendMessage = customRetrySendMessage || contextRetrySendMessage;

  return async (message) => {
    if (message) {
      await retrySendMessage(message);
    }
  };
};
